export const environment = {
  production: true,
  localserve: false,
  basehost: 'https://corpers-online.herokuapp.com',
  baseurl: 'https://corpers-online.herokuapp.com/api/v1.0',
  CORP_MEMBER_SOCKET_ENDPOINT: '/corp-member',
  env: 'HEROKU',
  
  // common
  GOOGLE_CLIENT_ID: '296914469678-1rka6pcijnui836mbju6kav902rio87n.apps.googleusercontent.com',
  ADMIN_HEADER_KEY: 'X-Admin-Key',
  ADMIN_HEADER_VALUE: 'UKN0W47N',
  EMAIL_VERIFICATION_REMINDER_ENABLED: true,
  ONBOARDING_CHECKLIST_ENABLED: false,

  CLOUDINARY_BASE_URL: 'https://res.cloudinary.com/dwkalnkvs',
};
